import gql from "graphql-tag";

export const PIN_POST = gql`
    mutation PinPost($postId: ID!) {
        pinPost(input: {
            postId: $postId,
        }){
            user{
                username
            }
        }
    }
`;
